import { type PropsWithChildren } from "react";

import { Box } from "@mui/material";

export default function TableHead({ disableStyling, ...props }: PropsWithChildren<{ disableStyling?: boolean }>) {
  return (
    <Box
      sx={
        disableStyling
          ? {
              mx: -2,
              zIndex: 20,
              gridColumn: "1 / -1",
              display: "grid",
              gridTemplateColumns: "subgrid",
            }
          : {
              position: "sticky",
              top: 0,
              mx: -2,
              mt: -7.5,
              pt: 8.5,
              px: 2,
              backgroundColor: (theme) =>
                `color-mix(in srgb, ${theme.vars.palette.background.default} 75%, transparent)`,
              backdropFilter: "blur(15px) saturate(125%)",
              zIndex: 20,
              gridColumn: "1 / -1",
              display: "grid",
              gridTemplateColumns: "subgrid",
            }
      }
    >
      <Box
        sx={[
          {
            gridColumn: "1 / -1",
            display: "grid",
            gridTemplateColumns: "subgrid",
            borderBottom: "1px solid #eee",
            alignItems: "center",
            justifyContent: "center",
            "&>*": {
              py: 1.5,
              px: 1,
            },
            "&>:first-child": {
              pl: 2,
            },
            "&>:last-child": {
              pr: 2,
            },
          },
          (theme) =>
            theme.applyStyles("dark", {
              borderBottomColor: "divider",
            }),
        ]}
        {...props}
      />
    </Box>
  );
}
